<template>
  <v-form
    lazy-validation
    id="insert"
    ref="insert"
    autocomplete="off"
    v-model="valid"
    @submit.prevent="submit"
  >
    <v-card>
      <v-card-title>
        <h3 class="primary--text">Nuova Categoria</h3>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-select
          label="Gruppo"
          item-text="text"
          item-value="value"
          item-color="accent"
          :items="groups"
          :rules="rules.group"
          v-model="category.reference"
          @change="category.parent_id = null"
        />
        <!-- <v-select
					label="Categoria Primaria"
					item-text="title"
					item-value="id"
					item-color="accent"
					:items="[
						{ id: null, title: 'Nessuna' },
						...this.categories.filter((el) => el.reference == this.category.reference),
					]"
					v-model="category.parent_id"
				/> -->
        <v-text-field
          label="Titolo"
          :rules="rules.title"
          v-model="category.title"
        />
        <v-textarea
          label="Descrizione"
          v-model="category.description"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          block
          type="submit"
          form="insert"
          color="primary"
        >
          Crea Categoria
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'CategorieCreateForm',
    data() {
      return {
        valid: false,
        category: {
          parent_id: null,
          reference: null,
          title: '',
          description: '',
        },
        groups: [{ text: 'Seleziona un gruppo', value: null }, { text: 'Movimenti', value: 'movimenti' }, { text: 'Operatori Telefonia Fissa', value: 'operatori telefonia fissa' }],
        rules: {
          group: [(v) => !!v || 'Campo obbligatorio.'],
          title: [(v) => !!v || 'Campo obbligatorio.']
        },
      }
    },

    computed: {
      ...mapGetters({
        categories: 'getCategoriesList',
      }),
    },

    methods: {
      ...mapActions({
        insert: 'insertCategory',
      }),

      async submit() {
        console.log('dsad')
        if (!this.$refs.insert.validate()) return

        this.insert(this.category)
          .then(() => {
            this.$refs.insert.reset()

            // this.addToStack({
            // 	color: 'success',
            // 	message: 'Categoria creata con successo!.',
            // })
          })
          .catch((e) => {
            console.log(e)
            // this.addToStack({
            // 	color: 'error',
            // 	message: 'Errore nella creazione della categoria..',
            // })
          })
      },
    },
  }
</script>
